// Content data for easywebswiss.ch

export const teamMembers = [
  {
    id: "valentina",
    name: "Valentina Randazzo",
    role: "Gründerin & CEO",
    image: "https://images.unsplash.com/photo-1643743323468-1e018b621231?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    phone: "+41 78 320 24 61",
    bio: {
      de: `Ich bin Valentina Randazzo, Gründerin von easywebswiss.ch – deine Ansprechpartnerin für professionelles Webdesign, SEO und Online-Marketing in der Schweiz.

Mein beruflicher Hintergrund verbindet Struktur, Technik und Marketing: Ich arbeitete bei GastroSocial in Aarau als stellvertretende Teamleiterin und betreute Gross- und Kettenkunden, insbesondere im Bereich digitaler Tools. Danach verlagerte sich mein Fokus vollständig auf Webdesign und Online-Marketing.

In der Schweiz, auf Mallorca und in Italien sammelte ich über Jahre Erfahrung im Aufbau professioneller Websites, Markenauftritte und Online-Strategien – zunächst für eine grosse, auf die Schweiz spezialisierte Firma, später selbstständig für verschiedene Unternehmen.

Heute unterstütze ich mit easywebswiss.ch vor allem KMU, Selbstständige und lokale Unternehmen in der Schweiz, auf Mallorca, in Italien und Deutschland mit:

• SEO-optimierten Websites
• modernem, benutzerfreundlichem Webdesign
• Online-Marketing & Content
• technischer Website-Betreuung
• klarer digitaler Positionierung

Ich arbeite technisch präzise, marketingorientiert und bilde mich laufend weiter. Kundinnen und Kunden schätzen meine offene Art, gemeinsame Lösungsfindung und Flexibilität.`,
      it: "Sono Valentina Randazzo, fondatrice di easywebswiss.ch – la vostra referente per web design professionale, SEO e marketing online in Svizzera.",
      en: "I'm Valentina Randazzo, founder of easywebswiss.ch – your contact for professional web design, SEO and online marketing in Switzerland.",
      es: "Soy Valentina Randazzo, fundadora de easywebswiss.ch – su contacto para diseño web profesional, SEO y marketing online en Suiza."
    },
    languages: ["Deutsch", "Italienisch", "Englisch", "Spanisch"]
  },
  {
    id: "nicola",
    name: "Nicola Violante",
    role: "Mitgründer & Technical Lead",
    image: "https://images.unsplash.com/photo-1768809249012-8589213560d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    phone: "+41 78 332 94 40",
    bio: {
      de: `Ich bin Nicola Violante, Mitgründer von easywebswiss.ch und dein Ansprechpartner für technisches Webdesign, Website-Entwicklung und Online-Marketing.

Mit meiner Ausbildung als Elektrotechniker in Hamburg und Erfahrung in der Gastronomie in Deutschland bringe ich technische Präzision und Kundenorientierung zusammen. Ich kümmere mich um Website-Betreuung, Entwicklung und SEO-Grundlagen.`,
      it: "Sono Nicola Violante, co-fondatore di easywebswiss.ch e il vostro referente per web design tecnico e sviluppo siti web.",
      en: "I'm Nicola Violante, co-founder of easywebswiss.ch and your contact for technical web design and website development.",
      es: "Soy Nicola Violante, cofundador de easywebswiss.ch y su contacto para diseño web técnico y desarrollo de sitios web."
    },
    languages: ["Deutsch", "Italienisch"]
  },
  {
    id: "vittoria",
    name: "Vittoria Donati",
    role: "Beraterin Tessin & Italien",
    image: "https://images.unsplash.com/photo-1588747020836-451633b46e87?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    phone: null,
    bio: {
      de: "Beraterin für Tessin & Italien mit Marketing- und Tourismus-Background. Spezialisiert auf Online-Marketing Strategien für den italienischsprachigen Markt.",
      it: "Consulente per Ticino e Italia con background nel marketing e turismo. Specializzata in strategie di marketing online per il mercato italiano.",
      en: "Consultant for Ticino & Italy with marketing and tourism background. Specialized in online marketing strategies for the Italian-speaking market.",
      es: "Consultora para Tesino e Italia con experiencia en marketing y turismo. Especializada en estrategias de marketing online para el mercado italiano."
    },
    languages: ["Italienisch", "Deutsch", "Englisch"]
  },
  {
    id: "shindy",
    name: "Shindy",
    role: "CEO & Bürohund",
    image: "https://images.unsplash.com/photo-1583318444357-e54d484ba7e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
    phone: null,
    bio: {
      de: "Zuständig für Pausenmanagement, Motivation und Work-Life-Balance. Sorgt für gute Stimmung im Team.",
      it: "Responsabile della gestione delle pause, motivazione e work-life balance.",
      en: "Responsible for break management, motivation and work-life balance.",
      es: "Responsable de la gestión de pausas, motivación y equilibrio trabajo-vida."
    },
    languages: ["Woof"]
  }
];

export const blogArticles = [
  {
    id: "online-marketing-kmu",
    slug: "online-marketing-fuer-kmu-schweiz",
    title: {
      de: "Online Marketing für KMU: So erreichst du deine Zielgruppe",
      it: "Marketing Online per PMI: Come raggiungere il tuo target",
      en: "Online Marketing for SMEs: How to Reach Your Target Audience",
      es: "Marketing Online para PYMES: Cómo llegar a tu público objetivo"
    },
    excerpt: {
      de: "Erfahre, wie du mit gezieltem Online Marketing mehr Kunden gewinnst. Von Social Media über Content Marketing bis hin zu bezahlter Werbung – ein Leitfaden für Schweizer KMU.",
      it: "Scopri come conquistare più clienti con il marketing online mirato. Dai social media al content marketing fino alla pubblicità a pagamento.",
      en: "Learn how to win more customers with targeted online marketing. From social media to content marketing to paid advertising.",
      es: "Aprende cómo ganar más clientes con marketing online dirigido. Desde redes sociales hasta marketing de contenidos y publicidad pagada."
    },
    content: {
      de: `## Online Marketing für KMU: Der komplette Leitfaden

Online Marketing ist heute für jedes Unternehmen unverzichtbar – besonders für KMU in der Schweiz. Mit den richtigen Strategien erreichst du deine Zielgruppe effektiv und gewinnst neue Kunden.

### Warum Online Marketing für KMU wichtig ist

- **Reichweite**: Erreiche potenzielle Kunden dort, wo sie sind – online
- **Messbarkeit**: Jede Kampagne ist messbar und optimierbar
- **Kosteneffizienz**: Günstiger als traditionelle Werbung
- **Zielgenauigkeit**: Erreiche genau deine Zielgruppe

### Die wichtigsten Online Marketing Kanäle

### 1. Social Media Marketing

Social Media ist perfekt für KMU:
- Facebook und Instagram für B2C
- LinkedIn für B2B
- Regelmässige Posts und Stories
- Community-Aufbau und Engagement

### 2. Content Marketing

Hochwertiger Content zieht Kunden an:
- Blog-Artikel mit Mehrwert
- Videos und Tutorials
- Infografiken und Guides
- Newsletter mit relevanten Tipps

### 3. Suchmaschinenmarketing (SEM)

Werde gefunden, wenn Kunden suchen:
- Google Ads für schnelle Sichtbarkeit
- SEO für langfristige Rankings
- Lokale Suchanzeigen für regionale KMU

### 4. E-Mail Marketing

Direkte Kommunikation mit Kunden:
- Newsletter für Bestandskunden
- Automatisierte E-Mail-Sequenzen
- Personalisierte Angebote

### Tipps für erfolgreiches Online Marketing

1. **Definiere deine Zielgruppe** – Wen willst du erreichen?
2. **Setze klare Ziele** – Was willst du erreichen?
3. **Wähle die richtigen Kanäle** – Wo ist deine Zielgruppe?
4. **Erstelle wertvollen Content** – Was interessiert deine Kunden?
5. **Miss und optimiere** – Was funktioniert, was nicht?

### Online Marketing mit easywebswiss.ch

Wir unterstützen dich bei:
- Social Media Betreuung
- Content-Erstellung
- Google Ads Kampagnen
- SEO-Optimierung

Kontaktiere uns für eine kostenlose Erstberatung!`,
      it: `## Marketing Online per PMI: La guida completa

Il marketing online è oggi indispensabile per ogni azienda – specialmente per le PMI in Svizzera. Con le giuste strategie raggiungi il tuo target in modo efficace e conquisti nuovi clienti.

### Perché il marketing online è importante per le PMI

- **Portata**: Raggiungi potenziali clienti dove si trovano – online
- **Misurabilità**: Ogni campagna è misurabile e ottimizzabile
- **Efficienza dei costi**: Più economico della pubblicità tradizionale
- **Precisione**: Raggiungi esattamente il tuo target

### I canali di marketing online più importanti

### 1. Social Media Marketing

I social media sono perfetti per le PMI:
- Facebook e Instagram per B2C
- LinkedIn per B2B
- Post e Stories regolari
- Costruzione della community e engagement

### 2. Content Marketing

Contenuti di qualità attraggono clienti:
- Articoli di blog con valore aggiunto
- Video e tutorial
- Infografiche e guide
- Newsletter con consigli utili

### 3. Search Engine Marketing (SEM)

Fatti trovare quando i clienti cercano:
- Google Ads per visibilità immediata
- SEO per ranking a lungo termine
- Annunci locali per PMI regionali

### Consigli per un marketing online di successo

1. **Definisci il tuo target** – Chi vuoi raggiungere?
2. **Fissa obiettivi chiari** – Cosa vuoi ottenere?
3. **Scegli i canali giusti** – Dove si trova il tuo target?
4. **Crea contenuti di valore** – Cosa interessa ai tuoi clienti?
5. **Misura e ottimizza** – Cosa funziona, cosa no?

Contattaci per una consulenza gratuita!`,
      en: `## Online Marketing for SMEs: The Complete Guide

Online marketing is essential for every business today – especially for SMEs in Switzerland. With the right strategies, you can effectively reach your target audience and win new customers.

### Why Online Marketing is Important for SMEs

- **Reach**: Reach potential customers where they are – online
- **Measurability**: Every campaign is measurable and optimizable
- **Cost efficiency**: Cheaper than traditional advertising
- **Precision**: Reach exactly your target audience

### The Most Important Online Marketing Channels

### 1. Social Media Marketing

Social media is perfect for SMEs:
- Facebook and Instagram for B2C
- LinkedIn for B2B
- Regular posts and stories
- Community building and engagement

### 2. Content Marketing

Quality content attracts customers:
- Blog articles with added value
- Videos and tutorials
- Infographics and guides
- Newsletters with relevant tips

### 3. Search Engine Marketing (SEM)

Be found when customers search:
- Google Ads for quick visibility
- SEO for long-term rankings
- Local ads for regional SMEs

### Tips for Successful Online Marketing

1. **Define your target audience** – Who do you want to reach?
2. **Set clear goals** – What do you want to achieve?
3. **Choose the right channels** – Where is your target audience?
4. **Create valuable content** – What interests your customers?
5. **Measure and optimize** – What works, what doesn't?

Contact us for a free initial consultation!`,
      es: `## Marketing Online para PYMES: La guía completa

El marketing online es hoy imprescindible para toda empresa – especialmente para las PYMES en Suiza. Con las estrategias correctas, llegas a tu público objetivo de manera efectiva y conquistas nuevos clientes.

### Por qué el Marketing Online es Importante para las PYMES

- **Alcance**: Llega a clientes potenciales donde están – online
- **Medición**: Cada campaña es medible y optimizable
- **Eficiencia de costos**: Más económico que la publicidad tradicional
- **Precisión**: Llega exactamente a tu público objetivo

### Los Canales de Marketing Online más Importantes

### 1. Marketing en Redes Sociales

Las redes sociales son perfectas para PYMES:
- Facebook e Instagram para B2C
- LinkedIn para B2B
- Posts y Stories regulares
- Construcción de comunidad y engagement

### 2. Marketing de Contenidos

El contenido de calidad atrae clientes:
- Artículos de blog con valor añadido
- Videos y tutoriales
- Infografías y guías
- Newsletters con consejos relevantes

### 3. Marketing en Buscadores (SEM)

Sé encontrado cuando los clientes buscan:
- Google Ads para visibilidad rápida
- SEO para rankings a largo plazo
- Anuncios locales para PYMES regionales

### Consejos para un Marketing Online Exitoso

1. **Define tu público objetivo** – ¿A quién quieres llegar?
2. **Establece objetivos claros** – ¿Qué quieres lograr?
3. **Elige los canales correctos** – ¿Dónde está tu público?
4. **Crea contenido valioso** – ¿Qué interesa a tus clientes?
5. **Mide y optimiza** – ¿Qué funciona, qué no?

¡Contáctanos para una consulta inicial gratuita!`
    },
    category: "Marketing",
    readTime: "10 min",
    publishedAt: "2025-01-15",
    image: "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: "seo-schweiz-2025",
    slug: "seo-schweiz-leitfaden-2025",
    title: {
      de: "SEO Schweiz 2025: Der komplette Leitfaden für bessere Rankings",
      it: "SEO Svizzera 2025: La guida completa per ranking migliori",
      en: "SEO Switzerland 2025: The Complete Guide for Better Rankings",
      es: "SEO Suiza 2025: La guía completa para mejores rankings"
    },
    excerpt: {
      de: "Lokale Suchmaschinenoptimierung für Schweizer Unternehmen. Lerne, wie du bei Google besser gefunden wirst und mehr organischen Traffic generierst.",
      it: "Ottimizzazione locale per i motori di ricerca per aziende svizzere. Scopri come essere trovato meglio su Google.",
      en: "Local search engine optimization for Swiss companies. Learn how to be found better on Google and generate more organic traffic.",
      es: "Optimización local de motores de búsqueda para empresas suizas. Aprende cómo ser encontrado mejor en Google."
    },
    content: {
      de: `## SEO Schweiz 2025: Der komplette Leitfaden

Suchmaschinenoptimierung (SEO) ist für Schweizer Unternehmen essentiell, um online gefunden zu werden. In diesem Leitfaden erfährst du alles, was du für bessere Rankings wissen musst.

### Was ist SEO und warum ist es wichtig?

SEO umfasst alle Massnahmen, die deine Website in den organischen Suchergebnissen nach oben bringen. Anders als bezahlte Werbung generiert SEO langfristig kostenfreien Traffic.

**Vorteile von SEO:**
- Nachhaltige Sichtbarkeit ohne laufende Werbekosten
- Höheres Vertrauen bei Nutzern
- Bessere User Experience
- Mehr qualifizierte Besucher

### Die wichtigsten SEO-Faktoren 2025

### 1. Technisches SEO

Die technische Basis muss stimmen:
- Schnelle Ladezeiten (Core Web Vitals)
- Mobile-Optimierung
- SSL-Zertifikat (HTTPS)
- Saubere URL-Struktur
- XML-Sitemap

### 2. On-Page SEO

Optimiere jede einzelne Seite:
- Relevante Keywords in Titeln und Texten
- Meta-Beschreibungen mit Handlungsaufforderung
- Strukturierte Überschriften (H1, H2, H3)
- Interne Verlinkung
- Optimierte Bilder mit Alt-Tags

### 3. Content-Qualität

Google liebt hochwertigen Content:
- Einzigartige, hilfreiche Inhalte
- Ausführliche Artikel (1500+ Wörter)
- Regelmässige Aktualisierungen
- Multimediale Inhalte (Bilder, Videos)

### 4. Lokales SEO für die Schweiz

Besonders wichtig für lokale Unternehmen:
- Google Business Profil optimieren
- Lokale Keywords verwenden ("Webdesign Zürich")
- NAP-Daten konsistent halten
- Bewertungen sammeln

### SEO-Besonderheiten für die Schweiz

- **Mehrsprachigkeit**: DE, FR, IT, EN berücksichtigen
- **.ch Domain**: Signalisiert Schweizer Relevanz
- **Schweizer Hosting**: Kann Rankings verbessern
- **Lokale Backlinks**: Von Schweizer Seiten

### Unsere SEO-Empfehlungen

1. Starte mit einem SEO-Audit
2. Definiere deine wichtigsten Keywords
3. Optimiere technische Grundlagen
4. Erstelle hochwertigen Content
5. Baue qualitative Backlinks auf
6. Tracke und optimiere kontinuierlich

### SEO-Services von easywebswiss.ch

Wir bieten:
- Umfassende SEO-Audits
- Keyword-Recherche für den Schweizer Markt
- On-Page und technische Optimierung
- Content-Erstellung
- Monatliches Reporting

Kontaktiere uns für eine kostenlose SEO-Erstberatung!`,
      it: `## SEO Svizzera 2025: La guida completa

L'ottimizzazione per i motori di ricerca (SEO) è essenziale per le aziende svizzere per essere trovate online. In questa guida scoprirai tutto ciò che devi sapere per migliorare i tuoi ranking.

### Cos'è la SEO e perché è importante?

La SEO comprende tutte le misure che portano il tuo sito web più in alto nei risultati di ricerca organici. A differenza della pubblicità a pagamento, la SEO genera traffico gratuito a lungo termine.

**Vantaggi della SEO:**
- Visibilità sostenibile senza costi pubblicitari continui
- Maggiore fiducia da parte degli utenti
- Migliore esperienza utente
- Più visitatori qualificati

### I fattori SEO più importanti nel 2025

### 1. SEO Tecnico

La base tecnica deve essere solida:
- Tempi di caricamento rapidi (Core Web Vitals)
- Ottimizzazione mobile
- Certificato SSL (HTTPS)
- Struttura URL pulita
- Sitemap XML

### 2. SEO On-Page

Ottimizza ogni singola pagina:
- Keyword rilevanti nei titoli e testi
- Meta descrizioni con call-to-action
- Intestazioni strutturate (H1, H2, H3)
- Link interni
- Immagini ottimizzate con alt tag

### 3. Qualità dei contenuti

Google ama i contenuti di qualità:
- Contenuti unici e utili
- Articoli approfonditi (1500+ parole)
- Aggiornamenti regolari
- Contenuti multimediali (immagini, video)

### 4. SEO Locale per la Svizzera

Particolarmente importante per le aziende locali:
- Ottimizzare il profilo Google Business
- Usare keyword locali ("Webdesign Zurigo")
- Mantenere dati NAP coerenti
- Raccogliere recensioni

Contattaci per una consulenza SEO gratuita!`,
      en: `## SEO Switzerland 2025: The Complete Guide

Search engine optimization (SEO) is essential for Swiss businesses to be found online. In this guide, you'll learn everything you need to know for better rankings.

### What is SEO and Why is it Important?

SEO includes all measures that bring your website higher in organic search results. Unlike paid advertising, SEO generates free traffic in the long term.

**Benefits of SEO:**
- Sustainable visibility without ongoing advertising costs
- Higher trust from users
- Better user experience
- More qualified visitors

### The Most Important SEO Factors in 2025

### 1. Technical SEO

The technical foundation must be solid:
- Fast loading times (Core Web Vitals)
- Mobile optimization
- SSL certificate (HTTPS)
- Clean URL structure
- XML sitemap

### 2. On-Page SEO

Optimize every single page:
- Relevant keywords in titles and texts
- Meta descriptions with call-to-action
- Structured headings (H1, H2, H3)
- Internal linking
- Optimized images with alt tags

### 3. Content Quality

Google loves quality content:
- Unique, helpful content
- Detailed articles (1500+ words)
- Regular updates
- Multimedia content (images, videos)

### 4. Local SEO for Switzerland

Especially important for local businesses:
- Optimize Google Business profile
- Use local keywords ("Web design Zurich")
- Keep NAP data consistent
- Collect reviews

Contact us for a free SEO consultation!`,
      es: `## SEO Suiza 2025: La guía completa

La optimización para motores de búsqueda (SEO) es esencial para que las empresas suizas sean encontradas online. En esta guía aprenderás todo lo que necesitas saber para mejores rankings.

### ¿Qué es SEO y por qué es importante?

El SEO incluye todas las medidas que llevan tu sitio web más arriba en los resultados de búsqueda orgánicos. A diferencia de la publicidad pagada, el SEO genera tráfico gratuito a largo plazo.

**Beneficios del SEO:**
- Visibilidad sostenible sin costos publicitarios continuos
- Mayor confianza de los usuarios
- Mejor experiencia de usuario
- Más visitantes cualificados

### Los factores SEO más importantes en 2025

### 1. SEO Técnico

La base técnica debe ser sólida:
- Tiempos de carga rápidos (Core Web Vitals)
- Optimización móvil
- Certificado SSL (HTTPS)
- Estructura de URL limpia
- Sitemap XML

### 2. SEO On-Page

Optimiza cada página individual:
- Palabras clave relevantes en títulos y textos
- Meta descripciones con llamada a la acción
- Encabezados estructurados (H1, H2, H3)
- Enlaces internos
- Imágenes optimizadas con etiquetas alt

### 3. Calidad del contenido

Google ama el contenido de calidad:
- Contenido único y útil
- Artículos detallados (1500+ palabras)
- Actualizaciones regulares
- Contenido multimedia (imágenes, videos)

### 4. SEO Local para Suiza

Especialmente importante para negocios locales:
- Optimizar perfil de Google Business
- Usar palabras clave locales ("Diseño web Zúrich")
- Mantener datos NAP consistentes
- Recopilar reseñas

¡Contáctanos para una consulta SEO gratuita!`
    },
    category: "SEO",
    readTime: "12 min",
    publishedAt: "2025-01-10",
    image: "https://images.unsplash.com/photo-1562577309-4932fdd64cd1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: "webdesign-trends-2025",
    slug: "webdesign-trends-2025",
    title: {
      de: "Webdesign Trends 2025: Moderne Websites für mehr Conversions",
      it: "Tendenze Webdesign 2025: Siti moderni per più conversioni",
      en: "Web Design Trends 2025: Modern Websites for More Conversions",
      es: "Tendencias Diseño Web 2025: Sitios modernos para más conversiones"
    },
    excerpt: {
      de: "Die wichtigsten Webdesign-Trends für 2025. Minimalistisches Design, schnelle Ladezeiten und mobile Optimierung – so überzeugt deine Website.",
      it: "Le tendenze più importanti del webdesign per il 2025. Design minimalista, tempi di caricamento rapidi e ottimizzazione mobile.",
      en: "The most important web design trends for 2025. Minimalist design, fast loading times and mobile optimization.",
      es: "Las tendencias más importantes de diseño web para 2025. Diseño minimalista, tiempos de carga rápidos y optimización móvil."
    },
    content: {
      de: `## Webdesign Trends 2025: Was moderne Websites ausmacht

Das Webdesign entwickelt sich ständig weiter. 2025 stehen User Experience, Performance und Ästhetik im Fokus. Hier erfährst du, welche Trends deine Website erfolgreicher machen.

### Die Top Webdesign-Trends 2025

### 1. Minimalistisches Design

Weniger ist mehr – auch im Webdesign:
- Klare Layouts ohne Ablenkung
- Viel Weissraum für bessere Lesbarkeit
- Fokus auf das Wesentliche
- Reduzierte Farbpaletten

### 2. Dark Mode & Dunkle Themes

Dunkle Designs sind beliebt:
- Elegant und modern
- Schonend für die Augen
- Spart Akkuleistung auf OLED-Displays
- Hebt Inhalte hervor

### 3. Micro-Animationen

Subtile Bewegungen verbessern die UX:
- Hover-Effekte für Interaktivität
- Scroll-Animationen
- Lade-Animationen
- Feedback bei Nutzeraktionen

### 4. Mobile-First Design

Mehr als 60% surfen mobil:
- Responsive Design ist Pflicht
- Touch-freundliche Elemente
- Schnelle Ladezeiten auf Mobilgeräten
- Vereinfachte Navigation

### 5. Typografie als Designelement

Schrift wird zum Hingucker:
- Grosse, auffällige Headlines
- Variable Fonts für Flexibilität
- Kreative Schriftkombinationen
- Lesbare Schriftgrössen

### 6. Performance-Optimierung

Schnelle Websites gewinnen:
- Core Web Vitals optimieren
- Bilder komprimieren
- Code minimieren
- CDN nutzen

### Warum gutes Webdesign wichtig ist

- **Erster Eindruck**: Besucher urteilen in Sekunden
- **Vertrauen**: Professionelles Design schafft Vertrauen
- **Conversion**: Gutes Design führt zu mehr Anfragen
- **SEO**: Google belohnt gute User Experience

### Design-Prinzipien von easywebswiss.ch

Wir setzen auf:
- **Clean Design**: Übersichtlich und klar strukturiert
- **Schnelle Performance**: Optimiert für beste Ladezeiten
- **Mobile-First**: Von Anfang an responsive
- **Conversion-Fokus**: Design, das verkauft

### Was kostet ein modernes Webdesign?

Unsere Pakete starten ab CHF 1'490 für professionelle Websites. Je nach Umfang und Funktionen passen wir das Angebot an deine Bedürfnisse an.

Kontaktiere uns für ein unverbindliches Angebot!`,
      it: `## Tendenze Webdesign 2025: Cosa rende moderno un sito web

Il web design è in continua evoluzione. Nel 2025 l'attenzione è sulla User Experience, le performance e l'estetica. Scopri quali tendenze renderanno il tuo sito web più efficace.

### Le Top Tendenze Webdesign 2025

### 1. Design Minimalista

Meno è più – anche nel web design:
- Layout chiari senza distrazioni
- Molto spazio bianco per una migliore leggibilità
- Focus sull'essenziale
- Palette di colori ridotte

### 2. Dark Mode & Temi Scuri

I design scuri sono popolari:
- Eleganti e moderni
- Riposanti per gli occhi
- Risparmio batteria su display OLED
- Mettono in risalto i contenuti

### 3. Micro-Animazioni

Movimenti sottili migliorano la UX:
- Effetti hover per interattività
- Animazioni di scroll
- Animazioni di caricamento
- Feedback sulle azioni dell'utente

### 4. Design Mobile-First

Oltre il 60% naviga da mobile:
- Il design responsive è obbligatorio
- Elementi touch-friendly
- Tempi di caricamento rapidi su mobile
- Navigazione semplificata

### 5. Tipografia come Elemento di Design

Il carattere diventa protagonista:
- Titoli grandi e accattivanti
- Font variabili per flessibilità
- Combinazioni creative di caratteri
- Dimensioni di carattere leggibili

### Perché un buon web design è importante

- **Prima impressione**: I visitatori giudicano in pochi secondi
- **Fiducia**: Un design professionale crea fiducia
- **Conversione**: Un buon design porta più richieste
- **SEO**: Google premia una buona User Experience

Contattaci per un preventivo senza impegno!`,
      en: `## Web Design Trends 2025: What Makes Modern Websites Stand Out

Web design is constantly evolving. In 2025, the focus is on User Experience, performance, and aesthetics. Discover which trends will make your website more successful.

### Top Web Design Trends 2025

### 1. Minimalist Design

Less is more – also in web design:
- Clear layouts without distraction
- Plenty of white space for better readability
- Focus on the essentials
- Reduced color palettes

### 2. Dark Mode & Dark Themes

Dark designs are popular:
- Elegant and modern
- Easy on the eyes
- Saves battery on OLED displays
- Highlights content

### 3. Micro-Animations

Subtle movements improve UX:
- Hover effects for interactivity
- Scroll animations
- Loading animations
- Feedback on user actions

### 4. Mobile-First Design

More than 60% browse on mobile:
- Responsive design is mandatory
- Touch-friendly elements
- Fast loading times on mobile devices
- Simplified navigation

### 5. Typography as Design Element

Font becomes the eye-catcher:
- Large, striking headlines
- Variable fonts for flexibility
- Creative font combinations
- Readable font sizes

### Why Good Web Design is Important

- **First impression**: Visitors judge in seconds
- **Trust**: Professional design builds trust
- **Conversion**: Good design leads to more inquiries
- **SEO**: Google rewards good User Experience

Contact us for a non-binding offer!`,
      es: `## Tendencias Diseño Web 2025: Lo que hace destacar a los sitios modernos

El diseño web está en constante evolución. En 2025, el enfoque está en la Experiencia de Usuario, el rendimiento y la estética. Descubre qué tendencias harán tu sitio web más exitoso.

### Las Principales Tendencias de Diseño Web 2025

### 1. Diseño Minimalista

Menos es más – también en diseño web:
- Layouts claros sin distracciones
- Mucho espacio en blanco para mejor legibilidad
- Enfoque en lo esencial
- Paletas de colores reducidas

### 2. Modo Oscuro & Temas Oscuros

Los diseños oscuros son populares:
- Elegantes y modernos
- Cómodos para los ojos
- Ahorra batería en pantallas OLED
- Destaca el contenido

### 3. Micro-Animaciones

Movimientos sutiles mejoran la UX:
- Efectos hover para interactividad
- Animaciones de scroll
- Animaciones de carga
- Feedback en acciones del usuario

### 4. Diseño Mobile-First

Más del 60% navega en móvil:
- El diseño responsive es obligatorio
- Elementos amigables al tacto
- Tiempos de carga rápidos en móviles
- Navegación simplificada

### 5. Tipografía como Elemento de Diseño

La fuente se convierte en protagonista:
- Titulares grandes y llamativos
- Fuentes variables para flexibilidad
- Combinaciones creativas de fuentes
- Tamaños de fuente legibles

### Por qué el Buen Diseño Web es Importante

- **Primera impresión**: Los visitantes juzgan en segundos
- **Confianza**: El diseño profesional genera confianza
- **Conversión**: El buen diseño lleva a más consultas
- **SEO**: Google premia la buena Experiencia de Usuario

¡Contáctanos para una oferta sin compromiso!`
    },
    category: "Webdesign",
    readTime: "8 min",
    publishedAt: "2025-01-05",
    image: "https://images.unsplash.com/photo-1547658719-da2b51169166?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  }
];

export const jobOpenings = [
  {
    id: "kundenkontakt",
    title: {
      de: "Kundenkontakt & Terminvereinbarung",
      it: "Contatto clienti e fissaggio appuntamenti",
      en: "Customer Contact & Appointment Scheduling",
      es: "Contacto con clientes y programación de citas"
    },
    type: "Teilzeit / Remote",
    location: "Schweiz (Remote)",
    description: {
      de: `Wir suchen eine motivierte Person für den Bereich Kundenkontakt und Terminvereinbarung.

**Deine Aufgaben:**
- Telefonische Akquise und Betreuung von Kunden
- Terminvereinbarung für Beratungsgespräche
- Pflege von Kundendaten im CRM
- Unterstützung bei administrativen Aufgaben

**Dein Profil:**
- Kommunikationsstark und kundenorientiert
- Sehr gute Deutschkenntnisse (weitere Sprachen von Vorteil)
- Erfahrung im Kundenkontakt
- Selbstständige Arbeitsweise

**Wir bieten:**
- Flexible Arbeitszeiten
- 100% Remote-Arbeit möglich
- Leistungsorientierte Vergütung
- Angenehmes Team

Interesse? Bewirb dich jetzt bei info@easywebswiss.ch!`,
      it: "Descrizione in italiano...",
      en: "Description in English...",
      es: "Descripción en español..."
    }
  }
];

export const companyInfo = {
  name: "easywebswiss.ch",
  company: "bitehub.randazzo",
  address: {
    street: "Breitenstrasse 20",
    zip: "5015",
    city: "Erlinsbach SO",
    country: "Schweiz"
  },
  uid: "CHE-422.954.335",
  email: "info@easywebswiss.ch",
  instagram: "easywebswiss.ch",
  phones: [
    { name: "Valentina", number: "+41 78 320 24 61" },
    { name: "Nicola", number: "+41 78 332 94 40" }
  ]
};

export const legalPages = {
  datenschutz: {
    title: "Datenschutzerklärung",
    content: `# Datenschutzerklärung

## Verantwortliche Stelle

easywebswiss.ch (by bitehub)
bitehub.randazzo
Breitestrasse 20
5015 Erlinsbach SO
Schweiz
UID: CHE-422.954.335
E-Mail: info@easywebswiss.ch

## 1. Allgemeines

Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Diese Datenschutzerklärung informiert darüber, welche Daten beim Besuch unserer Website sowie im Rahmen unserer Dienstleistungen (Webdesign, Webentwicklung, Online-Marketing) verarbeitet werden.

Wir halten uns an:
- die EU-Datenschutz-Grundverordnung (DSGVO) für Besucher aus der EU
- das Schweizer Datenschutzgesetz (DSG, revDSG)

## 2. Erhobene Daten

### a) Beim Besuch der Website

Beim Aufruf unserer Website werden automatisch folgende Daten erfasst (Server-Logfiles):
- IP-Adresse
- Datum und Uhrzeit
- Browsertyp und Version
- Betriebssystem
- Referrer-URL
- aufgerufene Seiten

**Zweck:** Sicherstellung des Betriebs, Sicherheit, Fehleranalyse
**Rechtsgrundlage:** Berechtigtes Interesse

### b) Kontaktaufnahme

Wenn Sie uns über Formular oder E-Mail kontaktieren:
- Name
- E-Mail-Adresse
- Telefonnummer (falls angegeben)
- Nachrichteninhalt

**Zweck:** Bearbeitung Ihrer Anfrage
**Rechtsgrundlage:** Vertragliche Massnahmen oder Einwilligung

### c) Kundenprojekte

Im Rahmen von Webdesign- oder Marketingprojekten verarbeiten wir je nach Auftrag:
- Kundendaten
- Zugangsdaten zu Hosting oder Tools
- Marketing- und Trackingdaten

Wir handeln dabei je nach Situation als Verantwortlicher oder Auftragsverarbeiter.

## 3. Cookies und Tracking

Unsere Website verwendet Cookies.

| Kategorie | Zweck | Einwilligung |
|-----------|-------|--------------|
| Notwendig | Betrieb der Website | Nein |
| Statistik | Besucheranalyse | Ja |
| Marketing | Werbung / Remarketing | Ja |

Nicht essenzielle Cookies werden erst nach Ihrer Zustimmung gesetzt.

## 4. Drittanbieter

Wir nutzen Dienste von:
- Hosting-Anbieter
- E-Mail-Provider
- Analyse-Tools
- Werbeplattformen

## 5. Speicherdauer

Daten werden nur solange gespeichert, wie erforderlich.

## 6. Ihre Rechte

Sie haben das Recht auf:
- Auskunft
- Berichtigung
- Löschung
- Einschränkung
- Datenübertragbarkeit
- Widerruf
- Beschwerde

## 7. Datensicherheit

Wir setzen technische Massnahmen ein:
- SSL/TLS Verschlüsselung
- Zugriffsbeschränkungen
- Regelmässige Backups

## 8. Kontakt

Bei Fragen zum Datenschutz:
info@easywebswiss.ch`
  },
  impressum: {
    title: "Impressum",
    content: `# Impressum

## Angaben gemäss Schweizer Recht

**easywebswiss.ch (by bitehub)**
bitehub.randazzo

Breitenstrasse 20
5015 Erlinsbach SO
Schweiz

**UID:** CHE-422.954.335

**E-Mail:** info@easywebswiss.ch

**Telefon:**
- Valentina Randazzo: +41 78 320 24 61
- Nicola Violante: +41 78 332 94 40

## Verantwortlich für den Inhalt

bitehub.randazzo
Breitenstrasse 20
5015 Erlinsbach SO

## Haftungsausschluss

Der Autor übernimmt keine Gewähr für die Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.

Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, die aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen entstanden sind, werden ausgeschlossen.

## Urheberrechte

Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf der Website gehören ausschliesslich der Firma easywebswiss.ch oder den speziell genannten Rechteinhabern.

## Social Media

**Instagram:** @easywebswiss.ch`
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen",
    content: `# Allgemeine Geschäftsbedingungen (AGB)

## 1. Geltungsbereich

Diese AGB gelten für alle Dienstleistungen von easywebswiss.ch (bitehub.randazzo), Breitenstrasse 20, 5015 Erlinsbach SO.

## 2. Leistungen

easywebswiss.ch bietet:
- Webdesign und Webentwicklung
- SEO-Optimierung
- Online-Marketing
- Website-Betreuung und Support

## 3. Angebote und Vertragsschluss

Angebote sind freibleibend. Ein Vertrag kommt durch schriftliche Auftragsbestätigung zustande.

## 4. Preise und Zahlung

- Preise verstehen sich in CHF, exkl. MwSt.
- Zahlungsfrist: 30 Tage
- Bei Verzug: Verzugszins von 5%

## 5. Lieferung und Termine

- Termine werden gemeinsam vereinbart
- Bei Verzögerungen durch Kunden verlängern sich Termine entsprechend

## 6. Mitwirkungspflichten

Der Kunde stellt rechtzeitig bereit:
- Texte und Bilder
- Zugangsdaten
- Feedback zu Entwürfen

## 7. Urheberrecht

- Bis zur vollständigen Bezahlung verbleibt das Eigentum bei easywebswiss.ch
- Nach Bezahlung gehen Nutzungsrechte an den Kunden über

## 8. Gewährleistung

- Mängel sind innert 14 Tagen schriftlich zu rügen
- easywebswiss.ch behebt Mängel kostenfrei

## 9. Haftung

Die Haftung beschränkt sich auf Vorsatz und grobe Fahrlässigkeit.

## 10. Geheimhaltung

Beide Parteien verpflichten sich zur Geheimhaltung vertraulicher Informationen.

## 11. Anwendbares Recht und Gerichtsstand

- Schweizer Recht
- Gerichtsstand: Aarau

## 12. Kontakt

easywebswiss.ch
info@easywebswiss.ch`
  },
  cookies: {
    title: "Cookie-Richtlinie",
    content: `# Cookie-Richtlinie

## Was sind Cookies?

Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, wenn Sie unsere Website besuchen.

## Welche Cookies verwenden wir?

### Notwendige Cookies

Diese Cookies sind für den Betrieb der Website erforderlich:
- Session-Cookies
- Cookie-Einstellungen

### Analyse-Cookies

Mit Ihrer Zustimmung verwenden wir:
- Google Analytics (zur Analyse des Nutzerverhaltens)

### Marketing-Cookies

Mit Ihrer Zustimmung:
- Werbe-Cookies für Remarketing

## Ihre Einstellungen

Sie können Ihre Cookie-Einstellungen jederzeit ändern über den Cookie-Banner oder Ihre Browser-Einstellungen.

## Kontakt

Fragen zu Cookies: info@easywebswiss.ch`
  }
};
